
import { AWS_ASSETS_URL } from "@/constants";
import {Options, Vue} from "vue-class-component";


@Options({
  name: 'svg-icon',
  props: {
    icon: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: "20"
    },
    height: {
      type: String,
      default: "20"
    },
    isCloudinary: {
      type: Boolean,
      default: false
    },
    isSvg: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getSrc() {
      if(this.isCloudinary) {
        return AWS_ASSETS_URL + this.icon;
      } else {
        return require(`../assets/svg/${this.icon}.svg`)
      }
    }
  },
})
export default class LegacyIcon extends Vue {}
